import { render, staticRenderFns } from "./xcx.vue?vue&type=template&id=6aae3f25&scoped=true"
var script = {}
import style0 from "./xcx.vue?vue&type=style&index=0&id=6aae3f25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae3f25",
  null
  
)

export default component.exports